import { CmtInfoType } from '@kinderlabs-pos/shared-data-type';

import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getCmtInfoListInStoreAsync = (rootUrl: string) => async () =>
	(await posAxiosClient.get<CmtInfoType[]>(`${rootUrl}/cmt/list/in-store/`)).data;
